ACC.productDetail = {

    dimension: $("#dimension").val(),
    dimensionValue: $("#dimensionValue").val(),
    dimensionTableCustomVariant: $("#dimension-table .custom-variant"),
    isEnterKeyLocked: false,
    productState: '',
    firstPriceRequestTimestamp: null,
    priceRequestRetryTimeout: function () {
        if (this.firstPriceRequestTimestamp == null) {
            this.firstPriceRequestTimestamp = new Date;
        }
        return new Date().getTime() - this.firstPriceRequestTimestamp.getTime()
    },

    initImageArrows: function () {
        var $prev = $('#colorbox .productImages .prev-img');
        if (!$prev.length) return;
        var $next = $('#colorbox .productImages .next-img');
        var $active = $('#colorbox .productImageGallery .thumb.active').parent();
        $active.index() <= 0 ? $prev.hide() : $prev.show();
        $active.index() >= $active.siblings().length ? $next.hide() : $next.show();
    },
    initCarouselElements: function () {
        $('.crossselling .jcarousel-skin').jcarousel();
    },

    initPageEvents: function () {
        $(document).on("click", "#imageLink", function (e) {
            e.preventDefault();

            $.colorbox({
                href: encodeURI($.base64.decode($(this).attr("data-zoom"))),
                height: false,
                innerWidth: 700,
                onLoad: function () {
                    $('#cboxClose').text(ACC.messages['text.pdp.imagePopup.close']);
                },
                onComplete: function () {
                    ACC.common.refreshScreenReaderBuffer();
                    ACC.productDetail.initImageArrows();
                    $('#colorbox .productImages .next-img').on("click", function () {
                        $('#colorbox .productImageGallery .thumb.active').parent().next().find('.thumb').trigger("click");
                    });
                    $('#colorbox .productImages .prev-img').on("click", function () {
                        $('#colorbox .productImageGallery .thumb.active').parent().prev().find('.thumb').trigger("click");
                    });
                },
                onClosed: function () {
                    ACC.common.refreshScreenReaderBuffer();
                }
            });
        });

        $('.js-add-to-quotecart').click(function (e) {
            // Workaround to show number of items in request cart immediately after adding item(s) without page reload.
            if($('.js-hidden-quote-request-minicart-amount .minicart-item-amount-wrapper').length === 0) {
                $('.js-hidden-quote-request-minicart-amount').append($('#hiddenQuoteRequestMinicartAmount').html());
            }
        });

        $(".productDetailsPanel .productImageGallery .thumb").click(function (e) {
            var $img = $(this).find('img');
            var $productImagePrimary = $(".productDetailsPanel .js-productImagePrimary img");
            $productImagePrimary.attr("src", $img.attr("data-primaryimagesrc"));
            $productImagePrimary.attr("title", $img.attr("title"));
            $("#imageLink").attr("data-zoom", $img.attr("data-galleryPositionUrl"));
            $(".productImageGallery .thumb").removeClass("active");
            $(this).addClass("active");
        });

        $(document).on("click", "#colorbox .productImageGallery .thumb", function (e) {
            var $productImagePrimary = $("#colorbox .js-productImagePrimary img");
            $productImagePrimary.attr("src", $(this).find('img').attr("data-zoomurl"));
            $productImagePrimary.attr("title", $(this).find('img').attr("title"));
            $("#colorbox .productImageGallery .thumb").removeClass("active");
            $(this).addClass("active");
            ACC.productDetail.initImageArrows();
        });

        $("#qtyInput").on('change', function (event) {
            if (!ACC.productDetail.showPrices()) {
                return;
            }
            var input = $(event.target);
            var value = $.trim(input.val());
            var qty_css = 'input[name=qty]';
            $('.no-quantity').addClass('hide');

            if ($('.file-upload-component')[0]) {
                return
                if (parseInt(value) > parseInt($('.js-sale-product-available .count').text())) {
                    // not available
                    $('.js-sale-product-available').addClass('not-available');
                    $('#qtyInput').addClass('not-available');
                    $('.addToCartButton-wrapper .js-add-to-cart-dropdown').addClass('disabled');
                    $('.js-availability-prefix').removeClass("hide");
                } else {
                    // available
                    $('.js-sale-product-available').removeClass('not-available');
                    $('#qtyInput').removeClass('not-available');
                    $('.addToCartButton-wrapper .js-add-to-cart-dropdown').removeClass('disabled');
                    $('.js-availability-prefix').addClass("hide");
                }
            }

            while (input.parent()[0] != document) {
                input = input.parent();
                if (input.find(qty_css).length > 0) {
                    input.find(qty_css).val(value);
                    return;
                }
            }
        });

        $("body").on("keyup", "select[name=certificateDropdown]", function (event) {
            var input = $(event.target);
            var value = input.val();
            var qty_css = 'input[name=certificate]';
            while (input.parent()[0] != document) {
                input = input.parent();
                if (input.find(qty_css).length > 0) {
                    input.find(qty_css).val(value);
                    return;
                }
            }
        });

        $('#certificateDropdown').on('change', function (event) {
            var input = $(event.target);
            var value = this.value;
            var certificateField = 'input[name=certificate]';
            while (input.parent()[0] != document) {
                input = input.parent();
                if (input.find(certificateField).length > 0) {
                    input.find(certificateField).val(value);
                    return;
                }
            }
        });

        $("body").on("keyup", "#foilingDropdown", function (event) {
            var input = $(event.target);
            var value = input.val();
            var qty_css = 'input[name=foiling]';
            while (input.parent()[0] != document) {
                input = input.parent();
                if (input.find(qty_css).length > 0) {
                    input.find(qty_css).val(value);
                    return;
                }
            }
        });

        $('#foilingDropdown').on('change', function (event) {
            var input = $(event.target);
            var value = this.value;
            var certificateField = 'input[name=foiling]';
            while (input.parent()[0] != document) {
                input = input.parent();
                if (input.find(certificateField).length > 0) {
                    input.find(certificateField).val(value);
                    return;
                }
            }
        });

        $("#Size").change(function () {
            var url = "";
            var selectedIndex = 0;
            $("#Size option:selected").each(function () {
                url = $(this).attr('value');
                selectedIndex = $(this).attr("index");
            });
            if (selectedIndex != 0) {
                window.location.href = url;
            }
        });

        $("#variant").change(function () {
            var url = "";
            var selectedIndex = 0;

            $("#variant option:selected").each(function () {
                url = $(this).attr('value');
                selectedIndex = $(this).attr("index");
            });
            if (selectedIndex != 0) {
                window.location.href = url;
            }
        });


        $(".selectPriority").change(function () {
            var url = $(this).attr('value');
            var selectedIndex = $(this).attr("index");

            if (selectedIndex != 0) {
                window.location.href = url;
            }
        });

        var dimensions = ACC.productDetail.dimension;
        var validateAddToCartButtonClick = function () {
            if ($('#needPostalcode').val() == "true") {
                KMVP.regionalassortment.forceEntryOfPostalCode();

                return false;
            }

            if ($('[data-state="selected"]').length < dimensions) {
                $('.js-no-dimensions').removeClass('hide');
                return false;
            }

            if (!ACC.productDetail.checkForFiles()) {
                $('.js-no-dimensions').removeClass('hide');
                return false;
            }

            if (!$.isNumeric($("#qtyInput").val()) || $("#qtyInput").val() <= 0) {
                $('.no-quantity').removeClass('hide');

                return false;
            }
        };

        $('.js-add-to-cart').on('click', validateAddToCartButtonClick);

        $('#qtyInput').on('keyup paste', ACC.common.delay(function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                $("#qtyInput").blur();
            }
            quantityChange();
            $("#qtyInput").change();
        }, 200));

        /*
         The idea for reset is to unselect selected dimension attributes by clicking them.
         But a real click is only done for the last element, because it will trigger an ajax call. And we only want to trigger it once.
         For that we call the same function as on click, but with a flag to skip the ajax call.
         The processing is done in reversed order because of sawing. For sawing there is a special handling implemented, which will disable some buttons.
         But if we do it reversed, then everything is fine.
        */
        $('.js-reset-attributes').on('click', function(e) {
            e.preventDefault();

            ACC.product.hidePerfectMatch();
            // We need to work with an array to easily reverse it.
            var elementsToClick = ACC.productDetail.getSelectedDimensionElementsForReset().get();

            elementsToClick.reverse();

            elementsToClick.forEach(function(element, index) {
                var $this = $(element);
                // Only click the last (as described above).
                if (index == elementsToClick.length-1) {
                    $this.click();
                } else {
                    selectVariantDimension({"target": $this.find('span')[0], "preventDefault": function(){}}, $this.attr('id'), true);
                }
            });
        });
    },

    /*
     Will collect elements which needs to be "clicked" during reset.
     When no dim labels, then nothing is done.
     If only 1 dim label the check if it is selected, if not then it is returned, because 1 dim label must always be selected.
     For more than 1 dim label we just return the selected one.
    */
    getSelectedDimensionElementsForReset: function() {
        return $('.js-product-variant-div .dim-wrapper').map(function() {
            var $this = $(this);
            var dimLabels = $this.find('.dim-label');
            if (dimLabels.length < 1) {
                return null;
            } else if (dimLabels.length == 1) {
                if (!$(dimLabels[0]).hasClass('selected')) {
                    return dimLabels[0];
                }

                return null;
            } else {
                var selectedDimLabels = $this.find('.dim-label.selected');
                if (selectedDimLabels.length > 0) {
                    return selectedDimLabels[0];
                }

                return null;
            }
        });
    },

    /*
     Enables/disabled the reset button.
    */
    setDimensionResetState: function () {
        if (ACC.productDetail.getSelectedDimensionElementsForReset().length > 0) {
            $('.js-reset-attributes').removeClass('disabled');
        } else {
            $('.js-reset-attributes').addClass('disabled');
        }
    },

    checkForFiles: function () {
        var filesUploaded = $('[data-upload-state="uploaded"]').length
        var uploadFileComponents = $('.file-upload-component').length
        if (filesUploaded < uploadFileComponents) {
            return false;
        }
        return true;
    },

    getSelectValue: function (code) {
        var value = "";
        var select = document.getElementById((code == "certificate" ? "certification" : code) + "List");
        if (select != null && select.options.length > 0) {
            if (select.selectedIndex >= 0) {
                value = select.options[select.selectedIndex].value;
                document.getElementById((code == "sprayPrimer" ? "primer" : code) + "Post").value = value;
            }
        }
        return value;
    },

    /*
     updates/fills in the foil-cert-spray POST values.
    */
    updateOptions: function () {

        ACC.productDetail.getSelectValue("certificate");
        ACC.productDetail.getSelectValue("foiling");
        ACC.productDetail.getSelectValue("sprayPrimer");
    },

    /*
    store selected certificate, foiling, sprayPrimer to session for master
    */
    storeOptionsToSessionForMaster: function () {

        $.session.set('selectedOptionForMaster', $('.js-master-product').val())
        $.session.set('selectedCertificateValue', $("#certificationList").val())
        $.session.set('selectedFoilingValue', $("#foilingList").val())
        $.session.set('selectedSprayPrimerValue', $("#sprayPrimerList").val())
        $.session.set('selectedDkgConservationValue', $("#dkgConservationList").val())
    },

    /*
    restore selected certificate, foiling, sprayPrimer to html
    */
    restoreOptionsFromSession: function () {

        var selectedCertificateValue = $.session.get('selectedCertificateValue')
        var selectedFoilingValue = $.session.get('selectedFoilingValue')
        var selectedSprayPrimerValue = $.session.get('selectedSprayPrimerValue')
        var selectedDkgConservationValue = $.session.get('selectedDkgConservationValue')

        $("#certificationList").val(selectedCertificateValue)
        $("#foilingList").val(selectedFoilingValue)
        $("#sprayPrimerList").val(selectedSprayPrimerValue)
        $("#dkgConservationList").val(selectedDkgConservationValue)
    },

    resetOptions: function () {
        var certificationList = $("#certificationList");
        var foilingList = $("#foilingList");
        var sprayPrimerList = $("#sprayPrimerList");

        if (certificationList != null && certificationList.length > 0) {
            certificationList.val("");
        }
        if (foilingList != null && foilingList.length > 0) {
            foilingList.val("");
        }
        if (sprayPrimerList != null && sprayPrimerList.length > 0) {
            sprayPrimerList.val("");
        }

        $.session.remove('selectedOptionForMaster');
        $.session.remove('selectedCertificateValue');
        $.session.remove('selectedFoilingValue');
        $.session.remove('selectedSprayPrimerValue');
        $.session.remove('selectedDkgConservationValue');
    },
    restoreOrResetOptions: function () {

        var selectedOptionForMaster = $.session.get('selectedOptionForMaster')

        if ($('.js-master-product').val() == selectedOptionForMaster) {
            this.restoreOptionsFromSession();
        } else {
            this.resetOptions();
        }
    },
    initZipCodePopup: function () {
        // todo: visibility of links and divs for zip-code should refactored:
        // visibility is controlled by class hide and css-display-attribute, problem: display in class hide is set to !important
        $('.add_zip_link, .add_zip_link_empty').on('click', function (e) {
            e.preventDefault();
            $(this).nextAll('.zip_code_popup_wrapper').show();
            $(this).nextAll('.zip_code_popup_wrapper').removeClass("hide");
            $(this).nextAll('.zip_code_popup_wrapper').find('.zip_code_input').select();
        });

        $('.zip_code_popup_cancel').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.zip_code_popup_wrapper').addClass("hide");
            $(this).closest('.zip_code_popup_wrapper').hide();
        });

        $('.zip_code_popup_wrapper').find('.send_zip_code').on('click', function (e) {
            e.preventDefault();
            var zip = $(this).closest('.zip_code_popup_wrapper').find('.zip_code_input').val().trim();
            var $deliveryDate = $('.js-delivery-date');
            $('.zip_code_popup_wrapper').hide();
            $('.zip_code_popup_wrapper').addClass("hide");
            $('.zip_code_popup_wrapper').find('.zip_code_input').val(zip);
            if (!zip) {
                $deliveryDate.find('.add_zip_link').hide();
                $deliveryDate.find('.add_zip_link').addClass("hide");
                $deliveryDate.find('.add_zip_link_empty').removeClass("hide");
                $deliveryDate.find('.add_zip_link_empty').show();
            } else {
                $deliveryDate.find('.add_zip_link').show().find('.zip_field').text(zip);
                $deliveryDate.find('.add_zip_link').removeClass("hide");
                $deliveryDate.find('.add_zip_link_empty').addClass("hide");
                $deliveryDate.find('.add_zip_link_empty').hide();
            }
            quantityChange(); // recalculate delivery date, availability, update zip in session cookie
        });
    },
    initDelivery: function () {
        var $deliveryDate = $('.js-delivery-date');
        var $deliveryDaysShowDelivery = $deliveryDate.find('.delivery-days.show-delivery');
        ACC.productDetail.updateDeliveryTime($deliveryDaysShowDelivery.text());
    },
    updateDeliveryTime: function (deliveryTime) {
        // Can happen if delivery date was not calculated.
        if (deliveryTime === undefined || deliveryTime == null) {
            return;
        }

        if (!deliveryTime) deliveryTime = '';

        var $deliveryDate = $('.js-delivery-date'),
            $deliveryDaysShowDelivery = $deliveryDate.find('.delivery-days.show-delivery'),
            $noDelivery = $('.js-no-delivery'),
            $showDelivery = $deliveryDate.find('.show-delivery'),
            noDeliveryCodes = ['', '-1', '-2'],
            index = $.inArray(deliveryTime, noDeliveryCodes),
            $quantityValue = $('.js-quantity-value').val();

        if (deliveryTime == null || deliveryTime == "" || deliveryTime == "-2") {
            ACC.productDetail.showDeliveryDate(false);
        } else {
            ACC.productDetail.showDeliveryDate(true);
        }

        if (index < 0) {
            $deliveryDaysShowDelivery.text(deliveryTime);
            $noDelivery.hide();
            $showDelivery.removeClass("hide");
            $showDelivery.show();
        } else {
            for (var i = 0; i < noDeliveryCodes.length; i++) {
                if ($.isNumeric($quantityValue) && $quantityValue > 0) {
                    if (index == i) {
                        $('.j-noDelivery' + i).removeClass('hide');
                    } else {
                        $('.j-noDelivery' + i).addClass('hide');
                    }
                } else {
                    $('.j-noDelivery' + i).addClass('hide');
                }
            }
            $noDelivery.show();
            $showDelivery.addClass("hide");
            $showDelivery.hide();
        }
    },

    updateAvailability: function (availability) {
        // Can happen if delivery date was not calculated.
        if (availability === undefined || availability == null) {
            return;
        }

        if (!availability) availability = 'DISABLED';
        $('.js-no-delivery')[(availability == 'ON_REQUEST' ? 'add' : 'remove') + 'Class']('hide');
        $('.j-availability')[(availability == 'DISABLED' ? 'add' : 'remove') + 'Class']('hide');
        $('.j-in-stock')[(availability == 'IN_STOCK' ? 'remove' : 'add') + 'Class']('hide');
        $('.j-partially-available')[(availability == 'PARTIALLY_AVAILABLE' ? 'remove' : 'add') + 'Class']('hide');
        $('.js-onrequest')[(availability == 'ON_REQUEST' ? 'remove' : 'add') + 'Class']('hide');
    },

    updateStockAvailability: function (stockAvailability) {
        $('.j-stock-availability')[(stockAvailability ? 'remove' : 'add') + 'Class']('hide');

        if (!stockAvailability) {
            return;
        }

        $('.j-badge')[(stockAvailability.labelThemeCode ? 'remove' : 'add') + 'Class']('hide');
        $('.j-selected-branch')[(stockAvailability.selectedBranch ? 'remove' : 'add') + 'Class']('hide');
        $('.j-branch-network')[(stockAvailability.branchNetwork ? 'remove' : 'add') + 'Class']('hide');
        $('.j-regional')[(stockAvailability.regional ? 'remove' : 'add') + 'Class']('hide');

        $('.j-badge').text(stockAvailability.labelThemeCode ? ACC.messages[stockAvailability.labelThemeCode] : "");
        $('.j-selected-branch-value').text(ACC.productDetail.formatStockAvailabilityData(stockAvailability.selectedBranch));
        $('.j-branch-network-value').text(ACC.productDetail.formatStockAvailabilityData(stockAvailability.branchNetwork));
        $('.j-regional-value').text(ACC.productDetail.formatStockAvailabilityData(stockAvailability.regional));
    },

    formatStockAvailabilityData: function (stockAvailabilityEntry) {
        if (stockAvailabilityEntry == null) {
            return '';
        }
        if (stockAvailabilityEntry.limited){
            return stockAvailabilityEntry.localizedLimitedString;
        }
        return stockAvailabilityEntry.amountPCE + ' ' + stockAvailabilityEntry.unitPCE + ' | ' + stockAvailabilityEntry.amountLBR + ' ' + stockAvailabilityEntry.unitLBR;
    },

    isVariant: function () {
        $('.no-variant-wrapper').unbind('mouseenter');
        $('.no-variant-wrapper').unbind('mouseleave');
        $('.no-variant-wrapper').removeClass('no-pointer').find('.no-variant-popup').addClass('hide');
        $(".page-productDetails .customProductNumber").addClass('hide');
        if ($('#variantCode').text().trim().length != 0) {
            $('.qty_block .no-variant-wrapper').addClass('no-pointer');
            if ($("#customCode").text().trim().length != 0) {
                $(".js-variant-custom-code .setCustomCode").removeClass('hide');
                $(".js-variant-custom-code .noCustomCode").addClass('hide');
                $(".custom_code_input").val($("#customCode").text());
            }
            $(".page-productDetails .customProductNumber").removeClass('hide');
        } else {
            $('.no-variant-wrapper').on('mouseenter',
                function () {
                    $(this).find('.no-variant-popup').removeClass('hide');
                }
            ).on('mouseleave',
                function () {
                    $(this).find('.no-variant-popup').addClass('hide');
                }
            );
        }
    },
    preSelectChosenDimensions: function () {
        var noDimensionsPresent = ($('.dim-wrapper').length) === 0;
        if (noDimensionsPresent) {
            // in case of missing dimension config we just trigger single variant selection in backend (callVariantResource)
            ACC.productDetail.storeSelectedValues(false);
            callVariantResource(ACC.productDetail.getAllDimensionCodes());
        } else {
            var $chosenDimensions = $('.js-dim-label[data-state="selected"]');

            // only for deeplink with product variant code as url parameter (dimension labels are selected)
            if ($chosenDimensions.length > 0) {
                $($chosenDimensions).each(function (index, value) {
                    var dimensionValue = $(value).attr('id'),
                        dimension = dimensionValue.substring(0, dimensionValue.indexOf("-"));
                    ACC.productDetail.disableNotSelectedVariants(dimension);
                });
                ACC.productDetail.storeSelectedValues(false);

                // we know the variant, but have to call callVariantResource. Its success method does too much stuff.
                callVariantResource(ACC.productDetail.getAllDimensionCodes()).done(function focus() {
                    setTimeout(function () {
                        ACC.productDetail._restoreUserSavedQuantity();
                        $("#qtyInput").focus();
                    }, 300)
                });
            }

            ACC.productDetail._preSelectAndSubmitVariationValues();
        }
    },
    selectOnlySelectableValuesRecursive: function () {
        // we don't have products with more variation attributes than that. Recursion limit to safeguard against unexpected behavior.
        var maxRecursions = 20;
        ACC.productDetail._selectOnlySelectableValuesRecursive(maxRecursions);
    },
    _selectOnlySelectableValuesRecursive: function (depth) {
        if (depth > 0 && ACC.productDetail._selectOnlySelectableDimensionValues(($('.js-product-variant-div .dim-wrapper')))) {
            ACC.productDetail._recalculateSelectableValuesRecursive(depth);
        }
    },
    _recalculateSelectableValuesRecursive: function (depth) {
        if (depth < 1) {
            throw new Error("This method does not handle depths lower than 1");
        }

        ACC.productDetail.storeSelectedValues(false);

        callVariantResource(ACC.productDetail.getAllDimensionCodes()).done(function focus() {
            setTimeout(function (depth) {
                ACC.productDetail._restoreUserSavedQuantity();
                $("#qtyInput").focus();
                ACC.productDetail._selectOnlySelectableValuesRecursive(--depth);
            }, 300, depth)
        });
    },
    _preSelectAndSubmitVariationValues: function () {
        var selectionChanged = ACC.productDetail._selectOnlySelectableDimensionValues($('.dim-wrapper'));
        if (ACC.productDetail._preSelectUserSavedVariationValues()) {
            selectionChanged = true;
        }

        if (selectionChanged) {
            ACC.productDetail._recalculateSelectableValuesRecursive();
        }
    },
    _restoreUserSavedQuantity: function () {
        var selection = JSON.parse($.session.get('selectedValues')),
            $quantity = $('.js-quantity-value');

        // restore quantity value, if possible and the same master product
        if (selection.qty !== "undefined" && selection.qty != null && $('.js-master-product').val() == selection.master) {
            $quantity.val(selection.qty);
            quantityChange();
            $quantity.change();
            $('.addToCartButton-wrapper .no-variant-wrapper').addClass('no-pointer');
        }

        // restore options
        ACC.productDetail.restoreOrResetOptions();
    },
    _preSelectUserSavedVariationValues: function () {
        if (!ACC.productDetail._hasUserSavedVariationValues()) {
            return false;
        }
        // when its only one variant...
        if ($(".js-has-single-variant").val() == "true") {
            ACC.productDetail.deleteChosenDimensions();
            return false;
        }

        // restore options
        ACC.productDetail.restoreOrResetOptions();

        // restore dimensions if selected before;
        var selection = JSON.parse($.session.get('selectedValues')),
            variants = selection.variants,
            selectionChanged = false;

        // restore selected dimension if its same master product
        if ($('.js-master-product').val() == selection.master) {
            $.each(variants, function setSelectedValues(i) {
                var $attributeValue = $("#" + variants[i]);
                if (!$attributeValue.closest('.dim-wrapper').find('.selected').length) {
                    ACC.productDetail._selectAttributeValue($attributeValue);
                    selectionChanged = true;
                }
            });
        }

        ACC.productDetail.setStateClass();

        return selectionChanged;
    },
    _hasUserSavedVariationValues: function() {
        var selectedValuesString = $.session.get('selectedValues');
        if (!selectedValuesString) {
            return false;
        }
        var selectedValues = JSON.parse(selectedValuesString);
        return selectedValues && selectedValues.variants && selectedValues.variants.length && $('.js-master-product').val() == selectedValues.master;

    },
    _selectOnlySelectableDimensionValues: function (dimensionWrappers) {
        var selectionChanged = false;
        for (var i = 0; i <= dimensionWrappers.length; i++) {
            var wrapperIndex = i + 1;
            var attributeValue = ACC.productDetail._getOnlySelectableAttributeValue(wrapperIndex);
            if (attributeValue.length === 1) {
                ACC.productDetail._selectAttributeValue(attributeValue);
                selectionChanged = true;
            }
        }
        return selectionChanged;
    },
    _getOnlySelectableAttributeValue: function(index) {
        var attributeValues = $(".js-product-variant-div .dim-wrapper-d" + index + " .dim-label");
        var disabledAttributeValues = $('.js-product-variant-div .dim-wrapper-d' + index + ' .dim-label[data-state="disabled"]');
        var selectedAttributeValues = $('.js-product-variant-div .dim-wrapper-d' + index + ' .dim-label[data-state="selected"]');
        var attributeValuesInSearchResult = $(".js-product-variant-div .dim-wrapper-d" + index + " .js-in-search-result");

        if (!attributeValues.length || selectedAttributeValues.length === 1) {
            return $();
        }
        // only one variant option is selectable
        if (attributeValues.length - disabledAttributeValues.length === 1) {
            return attributeValues.not('.disabled');
        }

        // multiple variants present, but search result indicates one
        if (attributeValuesInSearchResult.length - disabledAttributeValues.length === 1){
            return attributeValuesInSearchResult.not('.disabled');
        }
        return $();
    },
    _hasSearchFilteredVariationValues: function() {
        return $(".js-in-search-result").length;
    },
    _selectAttributeValue: function ($attributeValue) {
        $attributeValue.removeClass("orderable outofstock");
        $attributeValue.addClass("selected");
        $attributeValue.attr('data-state', "selected");
    },
    storeSelectedValues: function (changeQty) {
        var selection = {variants: []};

        if ($.session.get('selectedValues')) {
            var sessionSelection = JSON.parse($.session.get('selectedValues'));
        }
        // save master
        selection.master = $('.js-master-product').val();

        // save variant attributes
        $('#dimension-table div.dim-label').each(function () {
            if ($(this).attr('data-state') == "selected") {
                selection.variants.push($(this).attr('id'));
            }
        });
        // save qty
        if (changeQty || $('#qtyInput').val() && !sessionSelection) {
            selection.qty = $('#qtyInput').val();
        } else if (sessionSelection) {
            selection.qty = sessionSelection.qty;
        }
        $.session.set('selectedValues', JSON.stringify(selection));
    },
    setTotals: function (weight, price) {
        var atLeastOneItemVisible = false;

        if (weight) {
            $("#totalWeight").html(weight);

            $('.total-item-weight').removeClass('hide');

            atLeastOneItemVisible = true;
        } else {
            $("#totalWeight").html('');

            $('.total-item-weight').addClass('hide');
        }

        if (price) {
            $("#totalPrice").html(price);

            $('.total-item-price').removeClass('hide');

            atLeastOneItemVisible = true;
        } else {
            $("#totalPrice").html('');

            $('.total-item-price').addClass('hide');
        }

        if (atLeastOneItemVisible) {
            $('.js-total-item').removeClass('hide');
        } else {
            $('.js-total-item').addClass('hide');
        }
    },
    deleteChosenDimensions: function () {
        $.session.remove('selectedValues');
    },
    deselectChosenDimensions: function () {
        $("[class^='link-pdp-dimension']").each(function (index) {
            if ($(this).children().first().attr("data-state") === "selected") {
                $(this).trigger("click")
            }
        });
    },
    isCustomDimensionAllowed: function (dimension) {
        var isCustomDimensionAllowed = true;
        var $allSelection = ACC.productDetail.getAllSelection();
        var $empties = 0;
        var i = $allSelection.length;
        var dimVar = $('#dimension-table .dim-wrapper-' + dimension + ' .custom-variant');
        var lengthInArray = false;
        var widthInArray = false;
        var sheetSawing = false;

        //determine sheet sawing
        if ($('.custom-dimension-sheet-wrapper').length && $('.custom-dimension-sheet-wrapper').hasClass("sheet-variant")) {
            sheetSawing = true;
        }

        if (dimVar.length) {
            var dim = dimVar.attr('id').substring(0, ACC.productDetail.dimensionTableCustomVariant.attr('id').indexOf("-"));
        }

        while (i--) {
            if ($allSelection[i] == "") {
                $empties++;
            }
        }

        for (var j = 0; j < $allSelection.length; j++) {
            if ($allSelection[j].indexOf("length") != -1) {
                lengthInArray = true;
            }
            if (sheetSawing && $allSelection[j].indexOf("width") != -1) {
                widthInArray = true;
            }
        }

        if ((!sheetSawing &&
                (($empties == 1 && lengthInArray) ||
                    $empties > 1)
            ) ||
            (sheetSawing &&
                (($empties == 2 && lengthInArray && widthInArray) ||
                    $empties > 2)
            )
        ) {
            isCustomDimensionAllowed = false;
        }

        if ($empties == 0 &&
            dim == dimension) {
            if (sheetSawing) {
                var inputType = dimVar.hasClass("link-pdp-customWidth") ? "width" : "length";
                ACC.productSheetSawing.resetCustomSheetDimension(inputType, false);
            } else {
                ACC.productDetail.removeCustomDimension();
            }
        }

        ACC.productDetail.dimensionTableCustomVariant.unbind('mouseenter');
        ACC.productDetail.dimensionTableCustomVariant.unbind('mouseleave');

        if (!isCustomDimensionAllowed) {
            ACC.productDetail.forbidCustomDim();
        }
    },
    forbidCustomDim: function () {
        var $custDim = $('.custom-dimension-wrapper');

        ACC.productDetail.removeCustomDimension();
        ACC.productDetail.dimensionTableCustomVariant.addClass("not-active");
        // MiterSawing
        ACC.productMiterSawing.hideMiterSawingDataOnPDP();
        ACC.productMiterSawing.resetCustomMiterDimension();

        var countSelected = $('.dimension-table .dim-label[data-state="selected"]').length;
        var countUnselected = parseInt($('#dimension').val()) - parseInt(countSelected);

        if (countUnselected >= 2 ||
            (countUnselected == 1 && ($('.link-pdp-customLength').parent('li').children('.dim-label[data-state="selected"]').length > 0))) {
            ACC.productDetail.dimensionTableCustomVariant.on('mouseenter', function () {
                var popupWidth = $('.custom-dimension-wrapper').find('.custom-dimension-popup').width() / 2;
                var linkWidth = $(this).width() / 2;
                $custDim.removeClass('hide').find('.custom-dimension-popup').removeClass('hide').css("left", -(popupWidth - linkWidth));
            });
            ACC.productDetail.dimensionTableCustomVariant.on('mouseleave', function () {
                $custDim.addClass('hide');
                $custDim.find('.custom-dimension-popup').addClass('hide');
            });
        } else {
            ACC.productDetail.dimensionTableCustomVariant.on('mouseenter', function () {
                var popupWidth = $('.custom-dimension-wrapper').find('.custom-dimension-popup-no-sawing').width() / 2;
                var linkWidth = $(this).width() / 2;
                $custDim.removeClass('hide').find('.custom-dimension-popup-no-sawing').removeClass('hide').css("left", -(popupWidth - linkWidth));
            });
            ACC.productDetail.dimensionTableCustomVariant.on('mouseleave', function () {
                $custDim.addClass('hide');
                $custDim.find('.custom-dimension-popup-no-sawing').addClass('hide');
            });
        }
    },
    getAllSelection: function () {
        var variantsCount = ACC.productDetail.dimensionValue;
        var dimensionsCount = parseFloat(ACC.productDetail.dimension);
        var result = [];

        for (var dimension = 1; dimension <= dimensionsCount; dimension++) {
            var selectedDimensionName = "";

            for (var variant = 1; variant <= variantsCount; variant++) {
                var elementId = "d" + (dimension) + "-v" + (variant);
                var elemCode = $("#" + elementId + '-variant-code');
                var elem = $("#" + elementId);

                if (elem != null && elemCode != null) {
                    if (elem.attr('data-state') == "selected") {
                        selectedDimensionName = elemCode.text();
                        break;
                    }
                } else {
                    break;
                }
            }

            result.push(selectedDimensionName);
        }
        return result;
    },
    getSelectedVariantValues: function () {
        var variantsCount = $("#dimensionValue").val();
        var dimensionsCount = parseFloat($("#dimension").val());
        var result = [];

        for (var dimension = 1; dimension <= dimensionsCount; dimension++) {
            var selectedDimensionValue = "";

            for (var variant = 1; variant <= variantsCount; variant++) {
                var elementId = "d" + (dimension) + "-v" + (variant);
                var element = "d" + (dimension);
                var elem = $("#" + elementId);

                if (elem != null) {
                    if (!elem.length) {
                        break;
                    }
                    var currentdimension = elementId.substring(0, elementId.indexOf("-"));

                    if (currentdimension == element) {
                        if (elem.attr('data-state') == "selected") {
                            selectedDimensionValue = elem.find(".value").text();
                            break;
                        }
                    }
                } else {
                    break;
                }
            }

            result.push(selectedDimensionValue);
        }
        return result;
    },

    getAllDimensionCodes: function () {
        var variantsCount = ACC.productDetail.dimensionValue;
        var dimensionsCount = parseFloat(ACC.productDetail.dimension);
        var result = [];

        for (var dimension = 1; dimension <= dimensionsCount; dimension++) {
            var selectedDimensionName = "";

            for (var variant = 1; variant <= variantsCount; variant++) {
                var elementId = "d" + (dimension) + "-v" + (variant);
                var elemCode = $("#" + elementId + '-variant-code');
                var elem = $("#" + elementId);

                if (elem != null && elemCode != null) {
                    selectedDimensionName = elemCode.text();
                    break;
                } else {
                    break;
                }
            }

            result.push(selectedDimensionName);
        }
        return result;
    },
    setCustomDimension: function () {
        var $custDim = $('.custom-dimension-wrapper');

        ACC.productDetail.dimensionTableCustomVariant.on("click", function () {
            if (!$('.custom-dimension-miter-wrapper').hasClass("miter-variant") &&
                !$('.custom-dimension-sheet-wrapper').hasClass("sheet-variant") &&
                !$('.custom-dimension-miter-wrapper').hasClass("dkg-miter-variant")) {

                if (!$(this).hasClass("not-active") &&
                    !$(this).hasClass("custom-variant-selection")) {
                    // show popup for normal sawing:
                    $("#sawingType").val("DEGREE_90");
                    var popupWidth = $('.custom-dimension-wrapper').find('.custom-dimension-input-popup').width() / 2;
                    var linkWidth = $(this).width() / 2;
                    $('.custom-dimension-wrapper').removeClass("hide");
                    $('.custom-dimension-wrapper').find('.custom-dimension-input-popup').removeClass("hide").css("left", -(popupWidth - linkWidth));
                    $('.custom-dimension-wrapper').find('.custom-dimension-input-popup').find('.custom-dimension-input').select();
                }

                if ($(this).hasClass("custom-variant-selection")) {
                    ACC.productDetail.removeCustomDimension();
                    callVariantResource(ACC.productDetail.getAllDimensionCodes());
                }
            }
        });

        $('.custom-dimension-input-popup_cancel').on('click', function (e) {
            e.preventDefault();
            if (!$('.dkg-fix-cutting-overlay').length) {
                $(this).closest('.custom-dimension-wrapper').addClass("hide");
                $(this).closest('.custom-dimension-input-popup').addClass("hide");
            }
        });

        $('#dimension-table .send_custom-dimension').on("click", function (e) {
            e.preventDefault();

            ACC.productDetail.hideCustomDimensionPopupMessages();

            var $input = $('#dimension-table .custom-dimension-input');
            var inputValue = $input.val();

            $.ajax({
                async: false,
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                url: $(this).data('url'),
                data: JSON.stringify({
                    sawingType: "DEGREE_90",
                    sawingLength: inputValue,
                    selectionCodes: ACC.productDetail.getAllDimensionCodes(),
                    selectionValues: ACC.productDetail.getSelectedVariantValues()
                }),
                success: function (data, status) {
                    if (data.errorcode == 0) {
                        $('#customLength').val(data.sawingLength);
                        $('#qtyInput').prop("disabled", false);
                        $("#variantCode").val(data.variantCode);
                        callVariantResource(ACC.productDetail.getAllDimensionCodes());
                        quantityChange();
                    } else if (data.errorcode == 1) {
                        // Bad sawing-input length
                        $('.custom-dimension-wrapper .help-inline').removeClass("hide");
                        $custDim.find('.custom-dimension-validation-popup').removeClass('hide');
                        $('.custom-dimension-input').addClass("dimension-input-border");
                    } else if (data.errorcode == 2) {
                        // sawing length is out of range
                        $('.custom-dimension-input').addClass("dimension-input-border");
                        $(".custom-dimension-wrapper .help-inline").removeClass("hide");
                        $(".custom-dimension-wrapper .custom-dimension-minmax-popup").removeClass("hide");
                    }

                    ACC.productDetail.setDimensionResetState();
                }
            });
            $("#sawingTolerance").val($('.tolerance .custom-dimension-tolerance-select').val());
        });
    },
    handleCustomDimensionPopupResponse: function (isSuccess) {
        var customLength = $("#customLength").val();
        if (!customLength || customLength === "") return;
        if (isSuccess) {
            unselectAll($(".dimension-count-for-custom-dimension").val());
            ACC.productDetail.dimensionTableCustomVariant.addClass("custom-variant-selection").attr('data-state', "selected").find('.value').text($(".custom-dimension-input").val());
            $('.reset-icon').removeClass("hide");
            $('.custom-dimension-wrapper').addClass("hide");
            $('.custom-dimension-input-popup').addClass("hide");
        } else {
            $(".custom-dimension-wrapper .help-inline").removeClass("hide");
            $(".custom-dimension-wrapper .custom-dimension-response-error-popup").removeClass("hide");
            $('#customLength').val("");
        }
    },
    hideCustomDimensionPopupMessages: function () {
        var $customDimensionInputPopup = $('.custom-dimension-input-popup');
        $customDimensionInputPopup.find('.custom-dimension-input').removeClass("dimension-input-border");
        $customDimensionInputPopup.find('.help-inline').children().addClass('hide');
    },
    removeCustomDimension: function () {
        ACC.productDetail.dimensionTableCustomVariant.attr('data-state', "orderable");
        $("#sawingType").val("");
        $('#customLength').val("");
        $('#sawingTolerance').val("");
        $('.reset-icon').addClass("hide");
        ACC.productDetail.dimensionTableCustomVariant.removeClass("custom-variant-selection");
        ACC.productDetail.dimensionTableCustomVariant.find('.value').text(ACC.productDetail.dimensionTableCustomVariant.attr('data-placeholder'));
    },
    setCustomWidth: function () {
        var dimensionCount = ACC.productDetail.dimension;
        var dimensionValue = ACC.productDetail.dimensionValue;

        for (var i = 0; i < dimensionCount; i++) {
            for (var j = 0; j <= dimensionValue; j++) {
                var elementId = "d" + (i + 1) + "-v" + (j + 1);
                var elem = $("#" + elementId);

                if (elem != null) {
                    if (!elem.length) {
                        break;
                    }
                }
            }
        }
    },
    setStateClass: function () {
        var dimensionCount = ACC.productDetail.dimension;
        var dimensionValue = ACC.productDetail.dimensionValue;
        for (var i = 0; i < dimensionCount; i++) {
            for (var j = 0; j < dimensionValue; j++) {
                var elementId = "d" + (i + 1) + "-v" + (j + 1);
                var elem = $("#" + elementId);

                if (elem != null) {
                    if (!elem.length) {
                        break;
                    }
                    elem.removeClass("orderable selected disabled outofstock");

                    elem.addClass(elem.attr("data-state"));
                }
            }
        }
    },checkDimensions: function () {
        var dimensions = ACC.productDetail.dimension;
        if ($('[data-state="selected"]').length < dimensions || !ACC.productDetail.checkForFiles()) {
            $('.no-quantity').addClass('hide');
            $('#qtyInput').attr('disabled', 'disabled');
            $('#qtyInput').val('');
        } else {
            $('.js-no-dimensions').addClass('hide');
            $('#qtyInput').removeAttr("disabled");
        }
    },
    disableNotSelectedVariants: function (dimension) {
        var dimensionCount = ACC.productDetail.dimension;
        var dimensionValue = ACC.productDetail.dimensionValue;
        for (var i = 0; i < dimensionCount; i++) {
            var dim = "d" + (i + 1);
            for (var j = 0; j < dimensionValue; j++) {
                var elementId = "d" + (i + 1) + "-v" + (j + 1);
                var elem = $("#" + elementId);
                if (elem != null) {
                    if (!elem.length) {
                        break;
                    }
                }
                if (dim != dimension &&
                    elem.attr('data-state') != "selected") {
                    elem.removeClass("orderable");
                    elem.addClass("disabled");
                    elem.attr('data-state', "disabled");
                }
            }
        }
    },
    changeOptionSelect: function (select, dataList) {
        var length = select.options.length;

        if (select.options.length > 1) {
            for (i = 0; i < length - 1; i++) {
                select.remove(1);
            }
        }

        for (var i = 0; i < dataList.length; i++) {
            var option = document.createElement("option");
            option.text = dataList[i].description;
            option.value = dataList[i].code;
            select.add(option);
        }
    },
    changeOptionSelectWithClear: function (select, dataList, selectedValue) {
        var length = select.options.length;
        for (var i = length - 1; i >= 0; i--) {
            select.remove(i);
        }

        for (var i = 0; i < dataList.length; i++) {
            var option = document.createElement("option");
            option.text = dataList[i].name;
            option.value = dataList[i].code;
            if (selectedValue == dataList[i].code) {
                option.selected = true;
            }
            select.add(option);
        }
    },
    /**
     * Show Delivery and No-Delivery Date
     *
     * @param boolean (optional)
     */
    showDeliveryDate: function (show) {
        var $deliveryDate = $('.js-delivery-date'),
            $noDeliveryDate = $('.js-no-delivery'),
            $quantityValue = $('.js-quantity-value').val();

        if (typeof show != 'undefined' || show != null) {
            $($deliveryDate, $noDeliveryDate).toggleClass('d-none', !($.isNumeric($quantityValue) && $quantityValue > 0 && show));
        }
    },
    /**
     * Initialize Explanation Cart & Request for PDP
     */
    initExplanationCartAndRequest: function () {
        if ($("[class*='js-cart-request-explanation']:visible").length == 0) {
            if ($('.js-add-to-quotecart').length == 0) {
                ACC.productDetail.showExplanationCartAndRequest('merchant');
            } else {
                ACC.productDetail.showExplanationCartAndRequest('buyable');
            }
        }
    },
    /**
     * @param {string} buyable, requestable, merchant
     */
    showExplanationCartAndRequest: function (productState) {
        ACC.productDetail.productState = productState;
        //First hide all explanations
        $("[class*='js-cart-request-explanation']").addClass('d-none');

        if (typeof productState != 'undefined' || productState != null) {
            $('.js-cart-request-explanation-' + productState).removeClass('d-none');
        }
    },

    /**
     * Initialize custom popover for out of stock variants
     */
    initVariantSelectionPopover: function() {
        var $dimensionTable = $('#dimension-table');

        $dimensionTable.popover({
            html: false,
            trigger: 'hover',
            placement: 'bottom',
            content: function () {
                return $dimensionTable.attr('data-only-request-label');
            },
            selector: '.outofstock',
            container: '#productVariants',
            template: '<div class="custom-variant-popover"><div class="popover-body"></div></div>'
        });

        $dimensionTable.on('click', function () {
            $(this).find('[aria-describedby^=popover]').popover('hide');
        })
    },

    showPrices: function () {
        return $('#showPrices').val() == "true";
    },

	// updateQuantityAvailability: the availability object returned by updateQuantity ajax request.
	//                             Will be used to update availability when no availability object from price ajax
	//                             request is returned.
    loadPrices: function(updateQuantityAvailability) {
        if (!ACC.productDetail.showPrices()) {
            return;
        }
        $(".js-price-line").remove();
        $("#yourPrice").html($("<img class='spinner-img' src='" + ACC.config.resource.spinner + "'/>"));
        $("#priceRange").html($("<img class='spinner-img' src='" + ACC.config.resource.spinner + "'/>"));
        $("#totalPrice").html($("<img class='spinner-img' src='" + ACC.config.resource.spinner + "'/>"));

        // This is the only element which is shown initially. The others cannot be shown, because at this point it is not clear what prices will be
        // returned.
        $('.js-your-price-row').removeClass("hide");
        var sleepPeriod = 500;
        $.ajax({
            async: true,
            type: "POST",
            dataType: 'json',
            contentType: 'application/json',
            url: ACC.pdp.pricingPdpPricesUrl,
            data: JSON.stringify({
                certificate: ACC.productDetail.getSelectValue("certificate"),
                foilingCode: ACC.productDetail.getSelectValue("foiling"),
                priceUnitCode: $("#priceUnitPost").val(),
                quantity: $("#qtyInput").val(),
                quantityUnitCode: $("#qtyUnitPost").val(),
                sawingType: $("#sawingType").val(),
                sawingCode: $("#sawingCode").val(),
                sawingLength: $("#customLength").val(),
                sawingWidth: $("#customWidth").val(),
                sawingAngleA: $("#sawingAngleA").val(),
                sawingAngleB: $("#sawingAngleB").val(),
                sawingTolerance: $("#sawingTolerance").val(),
                sprayPrimer: ACC.productDetail.getSelectValue("sprayPrimer"),
                angleA:$("#processingAngleA").val(),
                angleB:$("#processingAngleB").val(),
                angleC:$("#processingAngleC").val(),
                angleD:$("#processingAngleD").val(),
                conservationId:$("#conservationId").val(),
                length:$("#processingLength").val(),
                processingId:$("#processingId").val(),
                variantProductCode: $("#productCodePost").val(),
                laserCuttingFileUniqueId: localStorage.getItem('laserCuttingFileUniqueId') ? localStorage.getItem('laserCuttingFileUniqueId') : "",
                sheetSawingLengthTolerance: $("#sawingLengthTolerance").val(),
                sheetSawingWidthTolerance: $("#sawingWidthTolerance").val(),
                waitPeriod :  ACC.productDetail.priceRequestRetryTimeout()
            }),

            error: function (data, status) {
                console.log(data);
                ACC.productDetail.addMessage(data);
                ACC.productDetail.refreshPriceInfo(data);

                if (updateQuantityAvailability) {
                    ACC.productDetail.updateAvailability(updateQuantityAvailability);
                }

                return;
            },

            success: function (data, status) {
                if (data && data.status && data.status === "ERROR"){
                    ACC.productDetail.addMessage(data);
                    ACC.productDetail.firstPriceRequestTimestamp = null;
                    return;
                }

                if (data && data.status && data.status === "READY") {
                    if (data.resultObject.calculationId) {
                        $('.addToCartButton').removeClass('disabled');
                        $('.js-add-to-cart-dropdown').removeClass('disabled');
                        localStorage.setItem('calculationId', data.resultObject.calculationId);
                    };
                    $('.gysi-error-pdp .gysi-error-message').text('');
                    if (localStorage.getItem('calculationId')) {
                        ACC.productDetail.getTotalWeightLaserCutting();
                    }
                    ACC.productDetail.refreshPriceInfo(data);
                    ACC.productDetail.firstPriceRequestTimestamp = null;

                    ACC.productDetail.updateDeliveryTime(data.resultObject.deliveryTime);
                    if (data.resultObject.availability !== undefined && data.resultObject.availability != null) {
                        ACC.productDetail.updateAvailability(data.resultObject.availability);
                    } else if (updateQuantityAvailability !== undefined && updateQuantityAvailability != null) {
                        ACC.productDetail.updateAvailability(updateQuantityAvailability);
                    }
                } else {
                    setTimeout(ACC.productDetail.loadPrices, sleepPeriod);
                }
            }
        });
    },

    addMessage: function (data) {
        if (!data.addToCartBlocked) {
            $('.addToCartButton').removeClass('disabled');
            $('.js-add-to-cart-dropdown').removeClass('disabled');
        } else {
            $('.addToCartButton').addClass('disabled');
            $('.js-add-to-cart-dropdown').addClass('disabled');
        }
        $('.gysi-error-pdp .gysi-error-message').text(data.errorMessage);
        $("#yourPrice").html('');
        $("#priceRange").html('');
        $("#totalPrice").html('');
        return;
    },

    clearTotalWeight: function () {
        $("#totalWeight").html("");
        $("#totalWeight").addClass("hide");
        $("#totalWeightLabel").addClass("hide");
    },

    getTotalWeightLaserCutting: function () {
        if (!localStorage.getItem('calculationId')) {
            return;
        }

        $.ajax({
            headers: {
                CSRFToken: ACC.config.CSRFToken,
            },
            dataType: 'json',
            contentType: 'application/json',
            url: ACC.pdp.getLaserCuttingWeightUrl + "?calculationId=" + localStorage.getItem('calculationId'),

            type: "GET",

            success: function (data) {
                if (data.totalWeight === null) {
                    this.clearTotalWeight();
                }
                else {
                    $("#totalWeight").html(data.totalWeight);
                    $("#totalWeight").removeClass("hide");
                    $("#totalWeightLabel").removeClass("hide");
                }
            },

            error: function () {
                this.clearTotalWeight();
            }
        })
    },

    /*
        Refreshes price info on page
    */
    refreshPriceInfo: function(data) {
        if (!data.resultObject) {
            return;
        }
        if (data.resultObject.calculationId) {
            localStorage.setItem('calculationId', data.resultObject.calculationId);
        }
        if (data.resultObject.priceLines) {
            var priceLineHtml = '';
            for (var i = 0; i < data.resultObject.priceLines.length; i++) {
                var priceLine = data.resultObject.priceLines[i];
                priceLineHtml += '<tr class="js-price-line">' +
                    '<td colspan="2">' +
                    '<table class="price-line-table">' +
                    '<tr>' +
                    '<td>' + priceLine.label + '</td>' +
                    '<td><span>' + priceLine.formattedValue + '</span></td>' +
                    '</tr>' +
                    '</table>' +
                    '</td>' +
                    '</tr>';
            }
            $("#js-quantity-tr").after(priceLineHtml);
        }

        var showYourPriceRow = false;

        if (data.resultObject.variantPrice && data.resultObject.variantPrice.formattedValue) {
            $("#yourPrice").html(data.resultObject.variantPrice.formattedValue);

            showYourPriceRow = true;
        } else {
            $("#yourPrice").html("--");
        }

        if (data.resultObject.priceRange) {
            $("#priceRange").html(data.resultObject.priceRange);

            showYourPriceRow = true;
        } else {
            $("#priceRange").html("--");
        }

        if (showYourPriceRow) {
            $('.js-tooltip-popover-discount').removeClass("hide");
        } else {
            $('.js-your-price-row').addClass("hide");
            $('.js-tooltip-popover-discount').addClass("hide");
        }

        if (data.resultObject.variantPriceTotal && data.resultObject.variantPriceTotal.formattedValue) {
            ACC.productDetail.setTotals($('#totalWeight').text(), data.resultObject.variantPriceTotal.formattedValue);
        } else {
            ACC.productDetail.setTotals($('#totalWeight').text(), '');
        }
    }
};

$(document).ready(function initializePdp() {
    if ($(".page-productDetails").length) {
        with (ACC.productDetail) {
            initDelivery();
            initPageEvents();
            initZipCodePopup();
            setCustomWidth();
            isVariant();
            preSelectChosenDimensions();
            setDimensionResetState();
            initVariantSelectionPopover();
            if ($('#sawingType').val() === "MITER") {
                ACC.productMiterSawing.updatePageInfos();
                var url = ACC.productMiterSawing.sawingUrl + "/" + $('#miterSawingVariant').val();
                $.ajax({
                    url: url,
                    type: "GET",
                    async: false,
                    success: function (data) {
                        ACC.productMiterSawing.prepareMiterSawingPopup(data);

                        for (var i = 0; i < data.types.length; i++) {
                            if (data.types[i].type === $('#sawingCode').val()) {
                                $('.show-miter-form-name .value').text("Typ: " + data.types[i].type);
                                $('.show-miter-form-image .value').html("<img src='" + data.types[i].imgUrl + "'/>");
                                break;
                            }
                        }
                    }
                });
            } else if ($('#sawingType').val() === "SHEET") {
                ACC.productSheetSawing.submitSheetSawing();
            } else {
                var customLength = $("#customLength").val();
                if (!customLength || customLength === "") {
                    isCustomDimensionAllowed();
                }
            }

            getAllSelection();
            setCustomDimension();
            setStateClass();
            checkDimensions();
            initCarouselElements();
            initExplanationCartAndRequest();
        }

        ACC.customarticlecode.bindAll();

        $(window).keydown(function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode == 13) {
                if (ACC.productDetail.isEnterKeyLocked) {
                    // prevent multiple add to cart actions when enter key is enduring pressed
                    event.preventDefault();
                    return false;
                }
                ACC.productDetail.isEnterKeyLocked = true;
                if ($('.zip_code_popup_wrapper').is(":visible") == true) {
                    $('.zip_code_popup_wrapper:visible').find('.send_zip_code').trigger('click');
                    event.preventDefault();
                    return false;
                }
                if ($('.custom-dimension-wrapper').is(":visible") == true) {
                    $('.custom-dimension-wrapper:visible').find('.send_custom-dimension').trigger('click');
                    event.preventDefault();
                    return false;
                }
            }
        });

        $(window).keyup(function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode == 13) {
                ACC.productDetail.isEnterKeyLocked = false;
            }
        });

        $(document).mouseup(function (e) {
            var container = $('.zip_code_popup_wrapper');
            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0 // ... nor a descendant of the container
                && container.is(":visible")) {
                container.addClass('hide');
            }
        });

        $(document).mouseup(function (e) {
            var container = $('.custom-dimension-wrapper');
            var child = $('.custom-dimension-wrapper .custom-dimension-input-popup');

            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0 // ... nor a descendant of the container
                && container.is(":visible")
                && child.is(":visible")) {
                container.addClass('hide');
                child.addClass('hide');
            }
        });

        KMVP.logRocketService.trackEvent('product_detail_viewed_d2');
    }
});
